module.exports = __webpack_public_path__ + "img/IT0000101260681.885f785b.png";